import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BudgetClientService } from "../../../../../../services/budget/budget-client-service";
import { BudgetClientModel } from "../../../../../../models/rightstore/rightstore.models";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { ValidationsClientService } from "../../../../../../services/validations/validations-client.service";

@autoinject
@transient()
export class addRightstoreBundleDialog {
    constructor(private dialogClientService: DialogClientService, private budgetClientService: BudgetClientService,
        private notificationClientService: NotificationClientService,
        private validationsClientService: ValidationsClientService) { }

    businessUnitId: number;
    budget: BudgetClientModel;
    reload: (() => void);

    async activate(model: { businessUnitId: number, budgetId: number, reload: (() => void) }) {
        this.businessUnitId = model.businessUnitId;
        this.reload = model.reload;
        this.budget = await this.budgetClientService.get(model.budgetId ? model.budgetId : 0);
        this.budget.businessUnitId = this.businessUnitId;
    }

    async save() {
        try {
            await this.budgetClientService.save(this.budget).then(x => {
                if (x.validationResult && x.validationResult.hasError) {
                    this.validationsClientService.showValidationErrors(x.validationResult);
                } else {
                    this.dialogClientService.hide();
                    this.notificationClientService.show("Budget", "Saved successfully", NotificationType.Success);
                }
            });
            if (this.reload) this.reload();
        } catch (error) {
            this.notificationClientService.show("Budget", "Failed to save budget", NotificationType.Error);
        }
    }

    close() {
        this.dialogClientService.hide();
    }
}